<template>
  <div class="row request-create">
    <div class="col">
      <div class="row request-create-header">
        <div class="col mx-2">
          <form class="form-inline py-2 justify-content-between">
            <div class="d-flex align-items-center">
              <button type="button" class="btn btn-back btn-lg" @click="$router.go(-1)">
                <i class="fa fa-angle-left px-1"></i>
              </button>
              <input
                type="text"
                id="requestName"
                placeholder="Введите имя заявки"
                class="form-control form-control-lg ml-2"
                v-model="requestName"
              />
            </div>
            <div class="d-flex align-items-center">
              <button
                type="button"
                class="btn btn-secondary"
                @click="cancelRequest"
              >{{ $t('home.cancel') }}</button>
              <button
                type="button"
                class="btn btn-primary ml-2"
                @click="createRequest"
                :disabled="isBlockSaveButton || !this.requestName"
              >{{ $t('home.save') }}</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row request-create-body my-4 mx-2 px-2 py-4">
        <div class="col-7">
          <form>
            <div class="form-group row align-items-center">
              <label
                for="dedlineDate"
                class="col-2 form-control-label"
              >{{ $t('home.deadline_date') }}:</label>
              <form class="form-inline col-10">
                <datepicker id="dedlineDate" v-model="deadlineDate"></datepicker>
                <label for="dedlineTime" class="form-control-label ml-5">{{ $t('home.time') }}:</label>
                <timepicker id="dedlineTime" class="form-control-label ml-3" v-model="deadlineTime"></timepicker>
              </form>
            </div>
            <div class="request-create-toggle mt-2">
              <div class="d-flex align-items-center">
                <div class="status-filters d-flex align-items-baseline">
                  <div
                    class="status-fiter"
                    @click="toggeleInfoMap"
                    :class="{'filter-active' : isActiveInfoMap}"
                  >
                    <p class="h3">Инфокарта</p>
                  </div>
                  <div
                    class="status-fiter"
                    @click="toggeleTechMap"
                    :class="{'filter-active' : isActiveTechMap}"
                  >
                    <p class="h3">Техкарта</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group align-items-top mt-2" v-if="isActiveInfoMap">
              <textarea
                rows="16"
                class="form-control"
                id="requestDescriptionId"
                v-model="requestDescription"
              ></textarea>
            </div>
            <div class="tech-card form-group align-items-top mt-2" v-if="isActiveTechMap">
              <div class="tech-card__body" v-if="techMap.length > 0">
                <div
                  class="tech-card__body-item px-3 py-3"
                  v-for="(item, index) in techMap"
                  :key="index"
                  :title="item.printMachineName"
                >
                  <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div class="d-flex flex-wrap align-items-center">
                      <i
                        class="tech-card__body-toggle fa fa-angle-down cursor-pointer mr-3"
                        v-if="item.expanded"
                        @click="() => item.expanded = false"
                      ></i>
                      <i
                        class="tech-card__body-toggle fa fa-angle-right cursor-pointer mr-3"
                        v-else
                        @click="() => item.expanded = true"
                      ></i>
                      <div class="d-flex flex-column">
                        <span
                          class="tech-card__body-title"
                          :title="item.name"
                        >{{item.name}}, {{item.printing}} шт.</span>
                        <span
                          class="tech-card__body-name"
                          :title="item.name"
                        >{{item.printMachineName}}</span>
                      </div>
                    </div>
                    <i
                      class="tech-card__remove-item ico ico-delete cursor-pointer"
                      title="удалить"
                      @click="deleteTechMapItem(item.id)"
                    ></i>
                  </div>
                  <template v-if="item.expanded">
                    <div
                      class="tech-card__details pl-4 ml-1"
                      v-for="(section, index) in item.sections"
                      :key="index"
                    >
                      <template v-if="section.blocks.length > 0">
                        <p class="tech-card__details-section mt-2 mb-0">{{section.name}}</p>
                        <dl class="row my-0" v-for="(block, index) in section.blocks" :key="index">
                          <dt class="tech-card__details-block col-sm-3 my-0 py-0">{{block.name}}</dt>
                          <dd class="col-sm-9 my-0 py-0">{{block.value}}</dd>
                        </dl>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
              <div>
                <div
                  v-if="isAddFromBasketActive"
                  class="d-flex align-items-center justify-content-between mt-4"
                >
                  <select
                    class="form-control custom-select w-75"
                    v-model="selectedBasketItem"
                    id="selectFroomBasket"
                  >
                    <option value="null" selected>Выбрать продукт</option>
                    <option
                      v-for="cardItem in $store.state.calculatedCard"
                      :key="cardItem.id"
                      :value="cardItem.id"
                      :selected="cardItem.id === selectedBasketItem"
                    >{{ cardItem.data.name }}, {{ cardItem.data.printing }} шт., {{ (+cardItem.data.cost).toFixed(2) }}</option>
                  </select>
                  <div>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary px-3"
                      @click="closeAddFromBasket"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary px-3"
                      @click="updateCard"
                    >
                      <i class="fa fa-refresh"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-primary px-3"
                      @click="addToTechMapFromBasket"
                    >
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </div>
                <div class="text-right" v-else>
                  <button
                    type="button"
                    class="btn btn-primary mt-4"
                    @click="()=>isAddFromBasketActive = true"
                  >Добавить из корзины</button>
                </div>
              </div>
              <div>
                <textarea
                  placeholder="Добавить комментарий к техкарте"
                  rows="8"
                  class="form-control mt-4"
                  id="requestDescriptionId"
                  v-model="techMapDesc"
                ></textarea>
              </div>
            </div>
          </form>
        </div>
        <div class="col-5">
          <form>
            <div class="form-group row align-items-center" v-show="!isCanChangePrice">
              <label for="cost" class="col-3 form-control-label">{{ $t('home.price') }}:</label>
              <form class="form-inline col-9">
                <input
                  type="text"
                  class="form-control"
                  id="cost"
                  v-model="totalCost"
                  @blur="checkPrice"
                  :disabled="!isCanChangePrice"
                />
              </form>
            </div>
            <div class="form-group row align-items-center">
              <label for="dropzone" class="col-3 form-control-label">Макеты:</label>
              <div class="col-9 p-2 view-task-layouts-items">
                <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  :useCustomSlot="true"
                  @vdropzone-sending="sendingLayoutEvent"
                  @vdropzone-complete="onLayoutUploadComplete"
                >
                  <div class="dropzone-custom-content">
                    <h3 class="dropzone-custom-title">Для загрузки, перетяните файл сюда.</h3>
                    <div class="subtitle">...или нажмите для выбора файла из вашего компьютера</div>
                  </div>
                </vue-dropzone>
                <div v-if="isAddLayout">
                  <dl class="mt-4 px-4 py-2">
                    <dt class="my-0 py-0"></dt>
                    <dd class="my-0 py-0 d-flex justify-content-between">
                      <b>Ссылка:</b>
                    </dd>
                    <dt class="my-0 py-0"></dt>
                    <dd class="my-0 py-0">
                      <input type="text" class="w-100" v-model="newLayout.link" />
                    </dd>
                    <dt class="my-0 py-0"></dt>
                    <dd class="my-0 py-0">
                      <b>Описание:</b>
                    </dd>
                    <dt class="my-0 py-0"></dt>
                    <dd class="my-0 py-0">
                      <textarea rows="4" type="text" class="w-100" v-model="newLayout.description"></textarea>
                    </dd>
                    <div class="text-right">
                      <button
                        class="btn btn-sm btn-outline-primary mt-2"
                        @click="cancelAddLayout"
                      >Отмена</button>
                      <button
                        class="btn btn-sm btn-primary mt-2"
                        @click.prevent="saveNewLayout"
                      >Сохранить</button>
                    </div>
                  </dl>
                </div>
                <div v-else class="text-right">
                  <button
                    class="btn btn-sm btn-primary mt-2"
                    @click.prevent="addLayout"
                  >добавить ссылку</button>
                </div>
                <div>
                  <dl
                    class="mt-4 pl-4 d-flex justify-content-between"
                    v-for="layout in layouts"
                    :key="layout.id"
                  >
                    <div class="mr-2 py-2 layouts">
                      <dt class="my-0 py-0"></dt>
                      <template v-if="layout.file">
                        <dd class="my-0 py-0 d-flex">
                          <b>Файл:</b>
                        </dd>
                        <dt class="my-0 py-0"></dt>
                        <dd class="my-0 py-0">
                          <a
                            :href="`/api/file-manager/files/${layout.file.id}/download`"
                          >{{layout.file.name}}</a>
                        </dd>
                      </template>
                      <template v-else-if="layout.link">
                        <dd class="my-0 py-0 d-flex">
                          <b>Ссылка:</b>
                        </dd>
                        <dt class="my-0 py-0"></dt>
                        <dd
                          class="my-0 py-0 link layouts__link"
                          v-if="!layout.isInEdit"
                        >{{layout.link}}</dd>
                        <dd class="my-0 py-0" v-else>
                          <input type="text" class="w-100" v-model="layout.link" />
                        </dd>
                      </template>
                      <dt class="my-0 py-0"></dt>
                      <dd class="my-0 py-0">
                        <b>Описание:</b>
                      </dd>
                      <dt class="my-0 py-0"></dt>
                      <dd
                        class="my-0 py-0 layouts__link-description"
                        v-if="!layout.isInEdit"
                      >{{layout.description}}</dd>
                      <dd class="my-0 py-0" v-else>
                        <textarea rows="4" type="text" class="w-100" v-model="layout.description"></textarea>
                      </dd>
                      <div class="text-right" v-if="layout.isInEdit">
                        <button
                          class="btn btn-sm btn-outline-primary mt-2"
                          @click.prevent="cancelEditLayout(layout)"
                        >Отмена</button>
                        <button
                          class="btn btn-sm btn-primary mt-2"
                          @click.prevent="saveEditedLayout(layout)"
                        >Сохранить</button>
                      </div>
                    </div>
                    <div class="text-right view-task-layouts-items__actions">
                      <div
                        class="btn-group btn-group-sm btn-group-vertical"
                        create
                        role="group"
                        aria-label="Basic example"
                      >
                        <a
                          v-if="layout.file && !layout.isInEdit"
                          class="btn btn-secondary"
                          :href="`/api/file-manager/files/${layout.file.id}/download`"
                        >
                          <i class="fa fa-download cursor-pointer"></i>
                        </a>
                        <button
                          v-else-if="layout.link && !layout.isInEdit"
                          type="button"
                          class="btn btn-secondary"
                          @click="copyLayoutLink(layout)"
                        >
                          <i class="fa fa-copy cursor-pointer"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="editLayout(layout)"
                          v-if="!layout.isInEdit"
                        >
                          <i class="ico ico-pencil cursor-pointer"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="deleteLayout(layout.id)"
                          v-if="!layout.isInEdit"
                        >
                          <i class="ico ico-delete cursor-pointer"></i>
                        </button>
                      </div>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <modal v-if="showModal" @close="onClickNoButton(showModal)">
      <div slot="modal-title">{{ $t('shared.warning') }}</div>
      <div slot="modal-body">{{ $t('shared.do_you_want_leave') }}</div>
      <div slot="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="onClickNoButton(showModal)"
        >{{ $t('shared.no') }}</button>
        <button
          type="button"
          class="btn btn-primary"
          @click="onClickYesButton(showModal)"
        >{{ $t('shared.yes') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '../../../api'
import moment from 'moment'
import copy from 'copy-to-clipboard'
import { uniqueId } from 'lodash'
import vue2Dropzone from 'vue2-dropzone'

import datepicker from '../../../components/datepicker.vue'
import timepicker from '../../../components/timepicker.vue'
import modal from '../../../components/modal.vue'

export default {
  name: 'RequestCreate',
  components: {
    datepicker,
    timepicker,
    modal,
    vueDropzone: vue2Dropzone
  },
  props: {
    requestId: {
      default: null
    },
    isUpdate: {
      default: false
    },
    isFromCalculator: {
      default: false
    },
    checkedCardItems: {
      default: () => []
    }
  },
  data: () => {
    return {
      requestName: '',
      deadlineDate: null,
      deadlineTime: null,
      requestDescription: '',
      techMap: [],
      techMapDesc: '',
      totalCost: 0,
      layouts: [],
      storedLayouts: [],
      newLayout: {
        link: '',
        description: ''
      },
      isAddLayout: false,
      needToShowModal: true,
      showModal: false,
      isActiveInfoMap: true,
      isActiveTechMap: false,
      selectedBasketItem: null,
      isAddFromBasketActive: false,
      isBlockSaveButton: false,
      dropzoneOptions: {
        url: '/api/file-manager/upload',
        thumbnailWidth: 75,
        thumbnailHeight: 75,
        maxFilesize: 512,
        timeout: 360000,
        addRemoveLinks: true,
        parallelUploads: 5
      }
    }
  },
  methods: {
    createRequest () {
      if (!this.requestName) {
        return
      }

      const requestInfo = {
        name: this.requestName,
        price: this.totalCost,
        description: this.requestDescription,
        end_time: this.deadLineDateTime,
        layouts: this.layouts.map(x => {
          return {
            link: x.link,
            description: x.description,
            fid: x.file ? x.file.id : null
          }
        })
      }

      if (this.techMap.length > 0) {
        requestInfo.tech_map_desc = this.techMapDesc
        requestInfo.tech_map = this.techMap.map(x => x.id)
      } else {
        requestInfo.tech_map = null
        requestInfo.tech_map_desc = ''
      }

      this.isBlockSaveButton = true

      if (this.isUpdate) {
        api.post
          .updateRequest(this.requestId, requestInfo)
          .then(resp => {
            this.needToShowModal = false
            const createdRequestId = resp.data.data.request.id
            this.updateRequest(createdRequestId).then(() => {
              this.$router.push(`/ad-agent/view-request/${createdRequestId}`)
            })
          })
          .catch(() => {
            this.needToShowModal = false
            this.$router.push('/')
            this.$notify({
              message: 'Произошла ошибка',
              type: 'danger'
            })
          })
      } else {
        api.post
          .createRequest(requestInfo)
          .then(resp => {
            this.needToShowModal = false
            const createdRequestId = resp.data.data.request.id
            if (this.isFromCalculator) {
              this.clearCard()
            }
            this.updateRequest(createdRequestId).then(() => {
              this.$router.push(`/ad-agent/view-request/${createdRequestId}`)
            })
          })
          .catch(() => {
            this.needToShowModal = false
            this.$router.push('/')
            this.$notify({
              message: 'Произошла ошибка',
              type: 'danger'
            })
          })
      }
    },
    cancelRequest () {
      this.$router.push('/')
    },
    async setFieldsFromRequest (requestId) {
      await this.updateRequest(requestId)
      const request = this.$store.state.requests.find(x => x.id === requestId)
      if (!request) this.$router.push('/')
      this.requestName = request.name
      this.requestDescription = request.description
      this.totalCost = request.price
      this.layouts = request.layouts.map(x => {
        return {
          id: uniqueId(),
          link: x.link,
          description: x.description,
          file: x.file,
          isInEdit: false
        }
      })
      this.techMap = Object.keys(request.tech_map).map(x => {
        return { ...request.tech_map[x], id: x, expanded: false }
      })
      this.techMapDesc = request.tech_map_desc
      if (this.isUpdate) {
        this.totalCost = request.price
        this.techMap = Object.keys(request.tech_map).map(x => {
          return { ...request.tech_map[x], id: x, expanded: false }
        })
        this.techMapDesc = request.tech_map_desc
        this.deadlineDate = moment(request.end_time).format('DD-MM-YYYY')
        this.deadlineTime = moment(request.end_time).format('HH:mm')
      }
    },
    toggeleInfoMap () {
      this.isActiveInfoMap = true
      this.isActiveTechMap = false
    },
    toggeleTechMap () {
      this.isActiveInfoMap = false
      this.isActiveTechMap = true
    },
    deleteTechMapItem (id) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              this.techMap = this.techMap.filter(x => x.id !== id)
              this.totalCost =
                this.techMap.length > 0
                  ? this.techMap
                    .map(x => +x.cost)
                    .reduce((a, b) => a + b)
                    .toFixed(2)
                  : 0
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    addToTechMapFromBasket () {
      if (this.selectedBasketItem) {
        const selectedItem = this.$store.state.calculatedCard.find(
          x => x.id === this.selectedBasketItem
        )
        this.techMap.push({
          ...selectedItem.data,
          id: selectedItem.id,
          expanded: false
        })
        this.requestName += ` +${selectedItem.data.name}`
        this.totalCost = this.techMap
          .map(x => +x.cost)
          .reduce((a, b) => a + b)
          .toFixed(2)
      }
      this.selectedBasketItem = null
      this.isAddFromBasketActive = false
    },
    closeAddFromBasket () {
      this.selectedBasketItem = null
      this.isAddFromBasketActive = false
    },
    checkPrice () {
      this.totalCost = this.totalCost.replace(',', '.')
    },
    sendingLayoutEvent (file, xhr, formData) {
      formData.append('size', file.size)
    },
    onLayoutUploadComplete (file, xhr) {
      if (file.status === 'error') {
        this.$notify({
          message: `Файл ${file.name} не загружен`,
          type: 'danger'
        })

        this.$refs.myVueDropzone.removeFile(file)
      }

      if (file.status === 'success') {
        this.$notify({
          message: `Файл ${file.name} загружен`,
          type: 'success'
        })

        this.$refs.myVueDropzone.removeFile(file)

        this.layouts.push({
          id: uniqueId(),
          link: '',
          description: '',
          file: JSON.parse(file.xhr.response).data.file,
          isInEdit: false
        })
      }
    },
    addLayout () {
      this.isAddLayout = true
    },
    cancelAddLayout () {
      this.isAddLayout = false
      this.newLayout = {
        id: uniqueId(),
        link: '',
        description: '',
        file: null
      }
    },
    saveNewLayout () {
      if (this.newLayout.link) {
        this.layouts.push({ ...this.newLayout, isInEdit: false })
      }

      this.cancelAddLayout()
    },
    deleteLayout (id) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              const layoutIndex = this.layouts.findIndex(x => x.id === id)
              this.layouts.splice(layoutIndex, 1)
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    copyLayoutLink (item) {
      copy(item.link)
    },
    editLayout (item) {
      this.storedLayouts.push({ ...item })
      item.isInEdit = true
    },
    saveEditedLayout (item) {
      if (item.link || item.file) {
        item.isInEdit = false
        const layoutIndex = this.layouts.findIndex(x => x.id === item.id)
        this.layouts.splice(layoutIndex, 1, item)
        this.cleanStoredLayout(item)
      }
    },
    cancelEditLayout (item) {
      const layoutIndex = this.layouts.findIndex(x => x.id === item.id)
      const storedLayoutItem = this.storedLayouts.find(x => x.id === item.id)
      this.layouts.splice(layoutIndex, 1, storedLayoutItem)
      this.cleanStoredLayout(item)
    },
    cleanStoredLayout (item) {
      const storedLayoutIndex = this.storedLayouts.findIndex(
        x => x.id === item.id
      )
      this.storedLayouts.splice(storedLayoutIndex, 1)
    },
    ...mapActions({
      updateRequest: 'UPDATE_REQUEST',
      clearCard: 'CLEAR_CARD',
      updateCard: 'UPDATE_CARD'
    })
  },
  computed: {
    deadLineDateTime () {
      return moment(
        `${this.deadlineDate} ${this.deadlineTime}`,
        'DD-MM-YYYY HH:mm'
      ).format()
    },
    isCanChangePrice () {
      return this.techMap.length === 0
    }
  },
  async created () {
    await this.updateCard()

    this.requestId && (await this.setFieldsFromRequest(+this.requestId))
    if (this.isFromCalculator) {
      const selectedItems = this.$store.state.calculatedCard.filter(
        x => this.checkedCardItems.indexOf(x.id) >= 0
      )
      this.requestName = selectedItems.map(x => x.data.name).join(' + ')
      this.techMap = selectedItems.map(x => {
        return { ...x.data, id: x.id, expanded: false }
      })
      this.totalCost = this.techMap
        .map(x => +x.cost)
        .reduce((a, b) => a + b)
        .toFixed(2)
    }
  },
  beforeRouteLeave (to, from, next) {
    if ((this.requestDescription || this.requestName) && this.needToShowModal) {
      this.showModal = true
      this.showModal = this.onClickYesButton = () => {
        this.showModal = false
        next()
      }
      this.onClickNoButton = () => {
        this.showModal = false
      }
    } else {
      next()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let pageHeader = ''
      if (vm.isUpdate) {
        pageHeader = 'Редактирование заявки'
      } else {
        pageHeader = 'Создание заявки'
      }
      vm.$eventBus.$emit('pageHeaderChange', pageHeader)
    })
  }
}
</script>

<style lang="scss" scoped>
.request-create {
  textarea {
    resize: none;
  }
}

.request-create-header {
  .form-control {
    width: 550px;
  }
}

.request-create-body {
  border: 1px solid #dce1e6;
}

.tech-card {
  &__body {
    border: 1px solid #ced4da;
    border-radius: 4px;
  }

  &__body-item + &__body-item {
    border-top: 1px solid #ced4da;
  }

  &__body-toggle {
    color: #28bd8b;
    font-size: 18px;
  }

  &__body-title {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 700;
  }

  &__body-name {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #7b7c7d;
  }

  &__details {
    &-section {
      font-weight: 700;
    }

    &-block {
      color: #7b7c7d;
      font-size: 13px;
    }
  }

  &__remove-item {
    color: #7b7c7d;
  }
}

.dropzone {
  min-height: 100px;
  padding: 0px 20px;
  border-radius: 4px;
}

.layouts {
  width: calc(100% - 30px);

  &__link,
  &__link-description {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
